import { colorBackgroundTable } from "../../styles/styles";
import TableContainer from "@material-ui/core/TableContainer";
import React, { useEffect, useState } from "react";
import {
  Button,
  IconButton,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import Title from "../../components/Title";
import Tooltip from "@material-ui/core/Tooltip";
import PageHelpGuide from "../../components/PageHelpGuide";
import { EVENT_WEBHOOKS_HELP_DATA } from "../../constants/pageHelp/eventWebhooksHelp";
import { getStandardButtonStyles } from "../../styles/standardButtons";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { DeleteOutline, Edit } from "@material-ui/icons";
import EventWebhookModal from "./EventWebhookModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  ...getStandardButtonStyles(theme),
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    borderRadius: 16,
    backgroundColor: theme.palette.type === 'dark' ? '#2A2D32 !important' : theme.palette.background.paper,
  },
  tableHeader: {
    fontWeight: 'bold',
    backgroundColor: colorBackgroundTable(theme),
    color: "#ffffff",
    borderBottom: `1px solid ${theme.palette.divider}`,
    zIndex: 1,
    position: "sticky",
    top: 0,
  },
  scrollArea: {
    flex: 1,
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
}));

const EventWebhooks = () => {
  const classes = useStyles();
  const [webhooks, setWebhooks] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedWebhook, setSelectedWebhook] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [deletingWebhook, setDeletingWebhook] = useState(null);

  useEffect(() => {
    fetchWebhooks();
  }, []);

  const fetchWebhooks = async () => {
    try {
      const { data } = await api.get("/event-webhooks");
      setWebhooks(data);
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenModal = (webhook = null) => {
    setSelectedWebhook(webhook);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedWebhook(null);
    setModalOpen(false);
    fetchWebhooks();
  };

  const handleDelete = async (webhook) => {
    try {
      await api.delete(`/event-webhooks/${webhook.id}`);
      toast.success(i18n.t("eventWebhooks.modal.deleteSuccess"));
      fetchWebhooks();
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <MainContainer>
      <ConfirmationModal
        title={i18n.t("eventWebhooks.modal.deleteConfirm")}
        open={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        onConfirm={() => handleDelete(deletingWebhook)}
      >
        {i18n.t("eventWebhooks.modal.deleteConfirm")}
      </ConfirmationModal>

      <EventWebhookModal
        open={modalOpen}
        onClose={handleCloseModal}
        webhookId={selectedWebhook?.id}
      />

      <Paper className={classes.mainPaper} variant="outlined">
        <MainHeader>
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <PageHelpGuide
              helpData={EVENT_WEBHOOKS_HELP_DATA}
              tooltipText="Guía y Ayuda de Webhooks de Eventos (Haz clic para ver)"
            />
            <Title>{i18n.t("eventWebhooks.title")}</Title>
          </div>
          <MainHeaderButtonsWrapper>
            <Button
              variant="contained"
              className={classes.applyButton}
              onClick={() => handleOpenModal()}
            >
              {i18n.t("eventWebhooks.addButton")}
            </Button>
          </MainHeaderButtonsWrapper>
        </MainHeader>

        <TableContainer className={classes.scrollArea}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableHeader} align="center">{i18n.t("eventWebhooks.columns.name")}</TableCell>
              <TableCell className={classes.tableHeader} align="center">{i18n.t("eventWebhooks.columns.trigger")}</TableCell>
              <TableCell className={classes.tableHeader} align="center">{i18n.t("eventWebhooks.columns.method")}</TableCell>
              <TableCell className={classes.tableHeader} align="center">{i18n.t("eventWebhooks.columns.url")}</TableCell>
              <TableCell className={classes.tableHeader} align="center">{i18n.t("eventWebhooks.columns.actions")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {webhooks.map((webhook) => (
              <TableRow key={webhook.id}>
                <TableCell align="center">{webhook.name}</TableCell>
                <TableCell align="center">{webhook.trigger}</TableCell>
                <TableCell align="center">{webhook.method}</TableCell>
                <TableCell align="center">{webhook.url}</TableCell>
                <TableCell align="center">
                  <Tooltip title="Editar Webhook">
                    <IconButton
                      size="small"
                      onClick={() => handleOpenModal(webhook)}
                    >
                      <Edit style={{ color: "#00a8ff" }} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Eliminar Webhook">
                    <IconButton
                      size="small"
                      onClick={() => {
                        setDeletingWebhook(webhook);
                        setConfirmModalOpen(true);
                      }}
                    >
                      <DeleteOutline style={{ color: "#e84118" }} />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      </Paper>
    </MainContainer>
  );
};

export default EventWebhooks;
